import { EventEmitter } from "events"
import dispatcher from "../dispatcher"
import { IEquipmentDocument, ITimecardFullData } from "../models"

class EquipmentStore extends EventEmitter {
    private equipmentList: IEquipmentDocument[]
    private totalCount: number
    private selectedEquipment: IEquipmentDocument
    private page: number
    private limitOption: number[]
    private limit: number
    private search: string
    private selectedEquipmentTimecard: ITimecardFullData
    constructor() {
        super()
        this.setMaxListeners(0)
        this.equipmentList = []
        this.totalCount = 0
        this.selectedEquipment = null
        this.page = 0
        this.limitOption = [20, 50, 100]
        this.limit = this.limitOption[0]
        this.search = ""
        this.selectedEquipmentTimecard = null
    }

    setEquipmentList(data) {
        this.equipmentList = data.documents
        this.totalCount = data.totalDocumentCount
        if (data.page !== null) this.page = data.page
        if (data.limit) this.limit = data.limit
        if (data.search !== null) this.search = data.search
        this.emit("change")
    }

    setFilter(data) {
        this.search = data
        this.emit("change")
    }

    getEquipmentList() {
        return this.equipmentList
    }

    getPage() {
        return this.page
    }

    getLimit() {
        return this.limit
    }

    getLimitOption() {
        return this.limitOption
    }

    getSearch() {
        return this.search
    }

    setSelectedEquipment(data) {
        this.selectedEquipment = data
        this.emit("equipment_change")
    }

    setSelectedEquipmentTimecard(data) {
        this.selectedEquipmentTimecard = data
        this.emit("change")
    }

    getSelectedEquipment() {
        return this.selectedEquipment
    }

    getSelectedEquipmentTimecard() {
        return this.selectedEquipmentTimecard.Timecard
    }

    getSelectedEquipmentTimecardPending() {
        return this.selectedEquipmentTimecard.Pending
    }

    getTotalEquipmentCount() {
        return this.totalCount
    }

    handleActions(action) {
        switch (action.type) {
            case "GET_EQUIPMENT_List": {
                this.setEquipmentList(action.data)
                break
            }
            case "SELECTED_EQUIPMENT": {
                this.setSelectedEquipment(action.data)
                break
            }
            case "SELECTED_EQUIPMENT_TIMECARD": {
                this.setSelectedEquipmentTimecard(action.data)
                break
            }
            case "UPDATE_EQUIPMENT_FILTER_TEXT": {
                this.setFilter(action.data)
                break
            }
        }
    }
}

const equipmentStore = new EquipmentStore()
dispatcher.register(equipmentStore.handleActions.bind(equipmentStore))

export default equipmentStore
